<template>
  <div style="padding: 20px; background: rgb(221, 225, 230); border: 1px solid rgb(204, 204, 204)">
    <!-- <v-container fluid class="pa-0 pt-4"> -->
      <!-- El boton "Crear" lo renderiza el propio Modal (tiene activator), asi que para que el de
           importar quede en la misma linea van los dos dentro de un flex. flex-grow-0 evita que el
           v-layout raiz del Modal se coma todo el ancho. -->
      <div class="d-flex align-center">
        <Modal
          v-if="create_access"
          class="flex-grow-0"
          :button_name="'Crear ' + modal_title"
          :modal_title="modal_title"
          :page_title="page_title"
          :formBtn="formBtn"
          :dialog="dialog"
          :service="service"
          @updateDialog="updateDialog"
          @loadList="loadList(service)"
          :editItem="mainItem"
        />

        <v-btn v-if="create_access" outlined class="ml-3 mb-3 btn-third" @click="updateDialogImportExcel(true)">Importar {{ modal_title }}</v-btn>

        <!-- Dispara crons:generar_reposicion (el mismo que corre solo a las 01:00) para todos
             los almacenes. Corre en background: :loading/:disabled reflejan tanto el request
             de disparo como el polling mientras el proceso sigue corriendo del lado del server. -->
        <v-btn
          v-if="create_access"          
          color="blue-grey"
          dark
          prepend-icon="mdi-sync"
          class="ml-auto mb-3"
          :loading="loading_reposicion || reposicion_running"
          :disabled="loading_reposicion || reposicion_running"
          @click="confirmGenerarReposicion"
        >
          {{ reposicion_running ? "Generando reposición..." : "Generar reposición" }}
        </v-btn>
      </div>

      <GenerarReposicionModal
        :open="dialog_generar_reposicion"
        :loading="loading_reposicion"
        @cancel="closeGenerarReposicionDialog"
        @accept="generarReposicion"
      />

      <PoliticaLogModal :dialog="dialog_log" :rule="log_rule" @close="closeLog" />

      <ModalImportExcel
        v-if="create_access"
        :button_name="'Importar ' + modal_title"
        :modal_title="'Importar ' + modal_title"
        :page_title="page_title"
        formBtn="Importar"
        :dialog="dialog_import_excel"
        :service="service"
        @updateDialog="updateDialogImportExcel"
        @loadList="loadList(service)"
      />

      <!-- Las dos leyendas comparten renglon: el horario del cron a la izquierda y el resultado
           de la ultima corrida a la derecha (justo debajo del boton que la dispara). -->
      <div class="d-flex align-center justify-space-between mb-2">
        <span class="text-caption text-grey-darken-1">
          <v-icon size="small" class="mr-1">mdi-clock-outline</v-icon>
          El proceso de creación de tareas de reposición corre todos los días a la 1 AM
        </span>

        <!-- Resultado de la ultima corrida (la manual y la del cron de la 01:00 comparten cache).
             Va aparte del toast: el toast se pierde a los segundos y solo lo ve quien disparo el
             proceso, asi que el que entra despues a la pantalla no tenia forma de saber como
             termino la ultima generacion. -->
        <span
          v-if="reposicion_last_result"
          class="text-caption text-right ml-4"
          :class="reposicion_last_result.ok ? 'text-green-darken-2' : 'text-red-darken-2'"
        >
          <v-icon size="small" class="mr-1">{{ reposicion_last_result.ok ? "mdi-check-circle-outline" : "mdi-alert-circle-outline" }}</v-icon>
          Última generación ({{ reposicion_last_result.finished_at }}): {{ reposicion_last_result.msg }}
        </span>
      </div>

      <!-- Filtros -->
      <v-card class="mb-4" v-if="list_access">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>

              <div class="row pt-2">
                <div class="col-md-3">
                  <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacén" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3" v-if="!isClient()">
                  <v-combobox v-model="filters.client" density="comfortable" item-title="name" item-value="id" :items="clients" label="Cliente" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox v-model="filters.product" density="comfortable" item-title="label" item-value="id" :items="products" label="Producto" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.ubicacion_code" density="comfortable" label="Ubicación" autocomplete="off" clearable></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-select v-model="filters.origen" density="comfortable" item-title="name" item-value="id" :items="origenes" label="Origen" clearable></v-select>
                </div>

                <div class="pt-2" :class="isClient() ? 'col-md-12' : 'col-md-9'" style="display: flex; justify-content: end">
                  <v-btn color="info" @click="loadList(service)" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-- Tabla -->
      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :headers="headers" :items="list" item-value="id" :search="search" :loading="loading" loading-text="Cargando...">
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.product ? item.product.name : "-" }}
                <span class="text-caption text-grey-600 d-block">SKU: {{ item.product ? item.product.sku : "-" }}</span>
              </td>
              <td v-if="!isClient()">{{ item.client ? item.client.name : "-" }}</td>
              <td>{{ item.almacen ? item.almacen.name : "-" }}</td>
              <td>{{ getUbicaciones(item) }}</td>

              <td class="text-no-wrap">
                <v-tooltip bottom v-if="isDePolitica(item)">
                  <template v-slot:activator="{ props }">
                    <v-chip v-bind="props" color="indigo" size="small">Política</v-chip>
                  </template>
                  <span v-if="item.politica && item.politica.category">
                    {{ item.politica.category.name }}{{ item.politica.subcategory ? " / " + item.politica.subcategory.name : "" }}
                  </span>
                  <span v-else>Gestionada por una política de reposición</span>
                </v-tooltip>
                <v-chip v-else color="grey" size="small">Manual</v-chip>
                <v-tooltip v-if="item.observacion_politica" location="top">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" size="small" color="warning" class="ml-1">mdi-alert-outline</v-icon>
                  </template>
                  <span>{{ item.observacion_politica }}</span>
                </v-tooltip>
              </td>
              <td class="text-center text-no-wrap">
                {{ item.stock_min }} / {{ item.stock_max }}
                <!-- <v-tooltip bottom v-if="item.stock_max_below_pallet">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="warning" size="small" class="ml-1">mdi-alert</v-icon>
                  </template>
                  <span>
                    El máximo ({{ item.stock_max }}) es menor a un pallet ({{ item.units_per_pallet }}). Si una ubicación queda vacía se baja el pallet entero y se pasa del máximo.
                  </span>
                </v-tooltip> -->
              </td>
              <td class="text-center text-no-wrap">
                {{ formatDecimal(item.demanda_diaria) }}
                <v-tooltip v-if="item.fecha_calculo" location="top">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" size="small" color="grey" class="ml-1">mdi-information-outline</v-icon>
                  </template>
                  <span>Fecha de cálculo: {{ item.fecha_calculo }}</span>
                </v-tooltip>
              </td>
              <td>
                <v-chip :color="item.activo ? 'green' : 'red'" size="small">
                  {{ item.activo ? "Activa" : "Inactiva" }}
                </v-chip>
              </td>
              <td class="text-center text-no-wrap">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="update_access" v-bind="props" small color="blue" class="mr-2" v-on:click="editItem(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small"> mdi-eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="delete_access" v-bind="props" small color="red" class="mr-2" v-on:click="deleteItem(item)" size="small">mdi-delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="isDePolitica(item) || item.fecha_calculo" v-bind="props" small color="indigo" class="mr-2" v-on:click="openLog(item)" size="small">mdi-history</v-icon>
                  </template>
                  <span>Historial de la política</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />
    <!-- </v-container> -->
  </div>
</template>

<script>
import { reposicionRuleService } from "@/libs/ws/reposicionRuleService";
import { almacenService } from "@/libs/ws/almacenService";
import { productoService } from "@/libs/ws/productoService";
import { clientService } from "@/libs/ws/clientService";
import Constant from "@/constants/sections";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./ReposicionRuleModal.vue";
import ModalImportExcel from "./ModalImportExcel.vue";
import GenerarReposicionModal from "@/components/Rules/GenerarReposicionModal.vue";
import PoliticaLogModal from "./PoliticaLogModal.vue";

function codigosUbicaciones(item) {
  if (!item.locations || item.locations.length == 0) return "-";
  return item.locations.map((l) => (l.ubicacion ? l.ubicacion.code : "-")).join(", ");
}

export default {
  components: { Modal, ModalImportExcel, GenerarReposicionModal, PoliticaLogModal },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      rol_section: Constant.SECTION_RULES,
      service: reposicionRuleService,
      page_title: "Reglas de Reposicion",
      modal_title: "Regla de Reposicion",
      almacenes: [],
      clients: [],
      products: [],
      dialog_import_excel: false,
      dialog_generar_reposicion: false,
      loading_reposicion: false, //true mientras se dispara el proceso (POST inicial)
      reposicion_running: false, //true mientras el proceso sigue corriendo del lado del server
      reposicion_last_result: null, //resultado de la ultima corrida, se muestra debajo del boton
      checking_reposicion_estado: false, //evita solapar polls si uno anterior no respondio
      reposicion_poll_interval: null,
      dialog_log: false,
      log_rule: null,
      origenes: reposicionRuleService.ORIGENES,
      filters: {
        client: null,
        almacen: null,
        product: null,
        ubicacion_code: "",
        origen: null,
      },
      headers: [
        {
          title: "Producto",
          align: "left",
          sortable: true,
          key: "product.label",
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "client.name",
          visible_for_client: false,
        },
        {
          title: "Almacén",
          align: "left",
          sortable: true,
          key: "almacen.name",
        },
        {
          title: "Ubicación",
          align: "left",
          sortable: true,
          key: "ubicaciones",
          //Para que el orden y el buscador de la tabla tambien usen los codigos de ubicacion
          value: (item) => codigosUbicaciones(item),
        },
        {
          title: "Origen",
          align: "left",
          sortable: true,
          key: "origen",
        },
        {
          //Total de la regla: suma de todas sus ubicaciones, no por ubicacion
          title: "Stock mín / máx (total)",
          align: "center",
          sortable: false,
          key: "stock_min",
        },
        {
          title: "Demanda diaria",
          align: "center",
          sortable: true,
          key: "demanda_diaria",
        },
        {
          title: "Estado",
          align: "left",
          sortable: true,
          key: "activo",
        },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
    };
  },
  mounted() {
    this.loadAlmacenes();
    this.loadProducts();
    if (!this.isClient()) this.loadClients();

    //Saco la columna Cliente para el usuario cliente: el listado ya viene filtrado a lo suyo.
    this.headers = this.headers.filter((header) => {
      if (header.visible_for_client || header.visible_for_client == undefined) {
        return true;
      }
      return !this.isClient();
    });

    this.loadList(this.service);

    //Puede haber una corrida en curso disparada por otro usuario, o por el cron de la 01:00:
    //si es asi, el boton arranca deshabilitado y el polling sigue el proceso hasta que termine.
    this.checkReposicionEstadoInicial();
  },
  beforeUnmount() {
    this.stopPollingReposicionEstado();
  },
  methods: {
    isDePolitica(item) {
      return item.origen == reposicionRuleService.ORIGEN_POLITICA;
    },
    getUbicaciones(item) {
      return codigosUbicaciones(item);
    },
    formatDecimal(value) {
      if (value === null || value === undefined || value === "") return "-";
      return parseFloat(value).toFixed(2);
    },
    openLog(item) {
      this.log_rule = item;
      this.dialog_log = true;
    },
    closeLog() {
      this.dialog_log = false;
      this.log_rule = null;
    },
    updateDialogImportExcel(value) {
      this.dialog_import_excel = value;
    },
    getFilterParams() {
      var param = {};
      if (this.filters.client && this.filters.client.id) param.client = { id: this.filters.client.id };
      if (this.filters.almacen && this.filters.almacen.id) param.almacen = { id: this.filters.almacen.id };
      if (this.filters.product && this.filters.product.id) param.product = { id: this.filters.product.id };
      if (this.filters.ubicacion_code) param.ubicacion_code = this.filters.ubicacion_code;
      if (this.filters.origen) param.origen = this.filters.origen;
      // El listado es liviano y completo: la tabla pagina, busca y ordena del lado del cliente
      param.limit = 0;
      return param;
    },
    //El listado es liviano, se necesita la regla completa (ubicaciones con zona/almacen) para el modal
    loadItemAndOpenModal(item) {
      this.loading = true;
      this.service
        .get({ id: item.id })
        .then((response) => {
          if (!response.status || !response.result) {
            this.toast.error(response.msg || "No se encontró la regla.");
            this.close();
            return;
          }
          this.mainItem = response.result;
          this.dialog = true;
        })
        .catch((e) => {
          console.log("service.get error");
          console.log(e);
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    viewItem(item) {
      this.viewdIndex = this.list.indexOf(item);
      this.loadItemAndOpenModal(item);
    },
    editItem(item) {
      this.editedIndex = this.list.indexOf(item);
      this.loadItemAndOpenModal(item);
    },
    loadAlmacenes() {
      almacenService.filter({}).then((response) => {
        this.almacenes = response.result.list;
        //Si hay un unico almacen disponible, se preselecciona y se re-filtra la lista con el
        if (this.almacenes.length === 1 && this.filters.almacen == null) {
          this.filters.almacen = this.almacenes[0];
          this.loadList(this.service);
        }
      });
    },
    loadProducts() {
      //list_minify: payload liviano (id/name/sku/label) solo para el combo
      productoService.list_minify({}).then((response) => {
        this.products = response.result.list;
      });
    },
    loadClients() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("clientService.filter error", e);
        });
    },
    confirmGenerarReposicion() {
      if (this.reposicion_running) return; //el boton ya deberia estar deshabilitado, doble resguardo
      this.dialog_generar_reposicion = true;
    },
    closeGenerarReposicionDialog() {
      this.dialog_generar_reposicion = false;
    },
    generarReposicion(tipos_ubicacion) {
      if (this.loading_reposicion || this.reposicion_running) return; //guard de reentrada
      this.loading_reposicion = true;

      this.service
        .generar_reposicion({ tipos_ubicacion })
        .then((response) => {
          if (response.status) {
            this.toast.success(response.msg);
            this.reposicion_running = true;
            this.startPollingReposicionEstado();
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((e) => {
          this.toast.error(e);
        })
        .finally(() => {
          this.loading_reposicion = false;
          this.dialog_generar_reposicion = false;
        });
    },
    checkReposicionEstadoInicial() {
      this.service.generar_reposicion_estado().then((response) => {
        if (!response.status) return;

        this.reposicion_last_result = response.result.last_result;

        if (response.result.running) {
          this.reposicion_running = true;
          this.startPollingReposicionEstado();
        }
      });
    },
    startPollingReposicionEstado() {
      this.stopPollingReposicionEstado(); //por si quedo uno viejo corriendo
      this.reposicion_poll_interval = setInterval(() => {
        this.checkReposicionEstado();
      }, 5000);
    },
    stopPollingReposicionEstado() {
      if (this.reposicion_poll_interval) {
        clearInterval(this.reposicion_poll_interval);
        this.reposicion_poll_interval = null;
      }
    },
    checkReposicionEstado() {
      if (this.checking_reposicion_estado) return; //no solapar si la respuesta anterior no llego
      this.checking_reposicion_estado = true;

      this.service
        .generar_reposicion_estado()
        .then((response) => {
          if (!response.status) return;

          var termino = this.reposicion_running && !response.result.running;
          this.reposicion_running = response.result.running;
          this.reposicion_last_result = response.result.last_result;

          if (!this.reposicion_running) {
            this.stopPollingReposicionEstado();
            if (termino) this.showReposicionResult(response.result.last_result);
            this.loadList(this.service);
          }
        })
        .finally(() => {
          this.checking_reposicion_estado = false;
        });
    },
    showReposicionResult(last_result) {
      //Sin last_result (ej: el proceso murio antes de poder persistir el resultado, como un
      //fallo de permisos en storage) el usuario se quedaba sin feedback: el boton dejaba de
      //girar y no pasaba nada mas.
      if (!last_result) {
        this.toast.error("La generación de reposición terminó sin reportar un resultado. Revise el log del servidor.");
        return;
      }

      if (last_result.ok) this.toast.success("Generación de reposición finalizada. " + last_result.msg);
      else this.toast.error("Generación de reposición finalizada con errores. " + last_result.msg);
    },
  },
};
</script>
